import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type ThemeMode = 'light' | 'dark';

interface ThemeModeState {
  mode: ThemeMode;
}

const THEME_STORAGE_KEY = 'shares-vision-theme-mode';

const getBrowserThemePreference = (): ThemeMode => {
  if (typeof window !== 'undefined' && window.matchMedia) {
    const prefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches;
    return prefersDark ? 'dark' : 'light';
  }
  return 'light';
};

const getInitialThemeMode = (): ThemeMode => {
  if (typeof window !== 'undefined') {
    const storedTheme = localStorage.getItem(THEME_STORAGE_KEY);
    if (storedTheme === 'light' || storedTheme === 'dark') {
      return storedTheme;
    }
    return getBrowserThemePreference();
  }
  return 'light';
};

const initialState: ThemeModeState = {
  mode: getInitialThemeMode(),
};

const themeModeSlice = createSlice({
  name: 'themeMode',
  initialState,
  reducers: {
    toggleTheme: state => {
      state.mode = state.mode === 'light' ? 'dark' : 'light';
      if (typeof window !== 'undefined') {
        localStorage.setItem(THEME_STORAGE_KEY, state.mode);
      }
    },
    setTheme: (state, action: PayloadAction<ThemeMode>) => {
      state.mode = action.payload;
      if (typeof window !== 'undefined') {
        localStorage.setItem(THEME_STORAGE_KEY, action.payload);
      }
    },
  },
});

export const { toggleTheme, setTheme } = themeModeSlice.actions;
export default themeModeSlice.reducer;
